import React from 'react';

const InstagramInsights: React.FC = () => {
    return (
        <div>
            <h1>Instagram Insights</h1>
        </div>
    );
};

export default InstagramInsights;